import { gql } from 'apollo-angular';
import { ORGANIZATION_FRAGMENT } from './organization.fragment';

export const USER_PREFERENCE_FRAGMENT = gql`
  fragment UserPreferenceFragment on UserPreference {
    __typename
    id
    roles
    investmentStyles
    rehabComfortabilities
  }
`;

export const USER_CBSA_PREFERENCES_FRAGMENT = gql`
  fragment UserCbsaPreferencesFragment on UserCbsaPreference {
    id
    type
    preference
    updatedAt
  }
`;

export const USER_ENTITIES_FRAGMENT = gql`
  fragment UserEntitiesFragment on EntityUser {
    id
    entityId
    fullName
  }
`;

export const USER_FRAGMENT = gql`
  ${USER_PREFERENCE_FRAGMENT}
  ${USER_CBSA_PREFERENCES_FRAGMENT}
  ${USER_ENTITIES_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  fragment UserFragment on User {
    id
    firstName
    surname

    email
    emailConfirmedAt
    phoneNumber
    phoneNumberConfirmedAt

    roles
    isActive
    referralCode
    insertedAt
    submarkets {
      id
      name
      displayName
    }
    preference {
      ...UserPreferenceFragment
    }
    organization {
      ...OrganizationFragment
    }
    entities {
      ...UserEntitiesFragment
    }
    cbsaPreferences {
      ...UserCbsaPreferencesFragment
    }
  }
`;

export const USER_WITH_TOKEN_FRAGMENT = gql`
  ${USER_PREFERENCE_FRAGMENT}
  ${USER_CBSA_PREFERENCES_FRAGMENT}
  ${USER_ENTITIES_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  fragment UserWithTokenFragment on UserWithToken {
    token

    id
    firstName
    surname

    email
    emailConfirmedAt
    phoneNumber
    phoneNumberConfirmedAt

    roles
    isActive
    referralCode
    insertedAt
    submarkets {
      id
      name
      displayName
    }
    preference {
      ...UserPreferenceFragment
    }
    organization {
      ...OrganizationFragment
    }
    entities {
      ...UserEntitiesFragment
    }
    cbsaPreferences {
      ...UserCbsaPreferencesFragment
    }
  }
`;

export const SIGN_IN_WITH_MAGIC_LINK_FRAGMENT = gql`
  ${USER_PREFERENCE_FRAGMENT}
  ${USER_CBSA_PREFERENCES_FRAGMENT}
  ${USER_ENTITIES_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  fragment MagicLinkUserWithTokenFragment on MagicLinkUserWithToken {
    token

    id
    firstName
    surname

    email
    emailConfirmedAt
    phoneNumber
    phoneNumberConfirmedAt

    roles
    isActive
    referralCode
    insertedAt
    submarkets {
      id
      name
      displayName
    }
    preference {
      ...UserPreferenceFragment
    }
    organization {
      ...OrganizationFragment
    }
    entities {
      ...UserEntitiesFragment
    }
    cbsaPreferences {
      ...UserCbsaPreferencesFragment
    }
  }
`;

export const SIGN_IN_WITH_EMAIL_MAGIC_LINK_FRAGMENT = gql`
  ${USER_PREFERENCE_FRAGMENT}
  ${USER_CBSA_PREFERENCES_FRAGMENT}
  ${USER_ENTITIES_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  fragment SignInWithEmailMagicLinkFragment on EmailMagicLinkUserWithToken {
    token

    id
    firstName
    surname

    email
    emailConfirmedAt
    phoneNumber
    phoneNumberConfirmedAt

    roles
    isActive
    referralCode
    insertedAt
    submarkets {
      id
      name
      displayName
    }
    preference {
      ...UserPreferenceFragment
    }
    organization {
      ...OrganizationFragment
    }
    entities {
      ...UserEntitiesFragment
    }
    cbsaPreferences {
      ...UserCbsaPreferencesFragment
    }
  }
`;

export const SIGN_IN_WITH_SMS_MAGIC_LINK_FRAGMENT = gql`
  ${USER_PREFERENCE_FRAGMENT}
  ${USER_CBSA_PREFERENCES_FRAGMENT}
  ${USER_ENTITIES_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  fragment SignInWithSmsMagicLinkFragment on SmsMagicLinkUserWithToken {
    token

    id
    firstName
    surname

    email
    emailConfirmedAt
    phoneNumber
    phoneNumberConfirmedAt

    roles
    isActive
    referralCode
    insertedAt
    submarkets {
      id
      name
      displayName
    }
    preference {
      ...UserPreferenceFragment
    }
    organization {
      ...OrganizationFragment
    }
    entities {
      ...UserEntitiesFragment
    }
    cbsaPreferences {
      ...UserCbsaPreferencesFragment
    }
  }
`;
